<template lang="pug">
  vue-plotly(:data='graph_data' :layout='layout' :options='options' watchShallow="true" :autoResize="true" ref="bar")
</template>
<script>
import { mapGetters } from 'vuex'
import VuePlotly from '@/components/Plotly'
export default {
  computed: {
    ...mapGetters([
      'ration',
      'materials',
      'krachtvoer',
      'ruwvoer',
      'supplement',
      'nutrients'
    ]),
    trace_krachtvoer () {
      return {
        x: this.nutrients,
        y: this.krachtvoer,
        name: this.$t('label.krachtvoer'),
        marker: { color: 'rgba(74,128,255,1)' },
        type: 'bar'
      }
    },
    trace_ruwvoer () {
      return {
        x: this.nutrients,
        y: this.ruwvoer,
        name: this.$t('label.ruwvoer'),
        marker: { color: 'rgba(0,255,0,1)' },
        type: 'bar'
      }
    },
    trace_supplement () {
      return {
        x: this.nutrients,
        y: this.supplement,
        name: this.$t('label.supplement'),
        marker: { color: 'rgba(255,152,0,1)' },
        type: 'bar'
      }
    },
    trace_norm () {
      return {
        x: this.nutrients,
        y: this.nutrients.map(obj => '100'),
        name: this.$t('label.rantsoen.norm'),
        marker: { color: 'rgba(128,128,128,1)' },
        mode: 'lines',
        type: 'scatter'
      }
    },
    graph_data () {
      return [this.trace_ruwvoer, this.trace_krachtvoer, this.trace_supplement, this.trace_norm]
    },
    layout () {
      return {
        title: '',
        xaxis: {
          tickangle: -45,
          titlefont: {
            color: '#2c3e50'
          },
          tickfont: {
            color: '#2c3e50'
          }
        },
        yaxis: {
          title: this.$t('label.rantsoen.norm') + ' (%)',
          titlefont: {
            color: '#2c3e50'
          },
          tickcolor: '#2c3e50',
          tickfont: {
            color: '#2c3e50'
          }
        },
        legend: {
          orientation: 'h',
          x: 0.5,
          y: 1.3,
          xanchor: 'center',
          yanchor: 'top',
          font: {
            color: 'black',
            size: 12
          },
          bordercolor: '#2c3e50',
          borderwidth: 1
        },
        barmode: 'stack'
        // paper_bgcolor: 'rgba(94,95,96,0)',
        // plot_bgcolor: 'rgba(94,95,96,0)'
        // margin: { t: 50, l: 50, b: 75, r: 50 }
      }
    },
    options () {
      return { displayModeBar: false, showLink: false, displaylogo: false, scrollZoom: false, editable: false, modeBarButtonsToRemove: ['sendDataToCloud', 'toggleSpikelines'] }
    }
  },
  components: { VuePlotly }
}
</script>



// WEBPACK FOOTER //
// src/components/BarChart.vue